export default [
  {
    path: '',
    name: 'review list',
    component: () => import('@/views/app/review/page-list.vue'),
    meta: { title: 'Daftar Ulasan' },
  },
]
